import { StorageProviderType } from './storage-provider-type.enum';

export const STORAGE_PROVIDER_CONSTANTS = {
  APP_NAME: 'fusion',
  DEFAULT_PROVIDER: StorageProviderType.localStorage,
  DELIMITER: '.',
  ORG_NAME: '@cognite',
  SUB_APP_NAME: 'data-modeling',
};
